import get from 'lodash/get'
import { isValid, isBefore } from 'date-fns'

// Original ref: https://github.com/LendioDevs/home-portal/blob/8e89a3d25d4afb4b3f33b3d72fe3766d58e60bd2/wp-content/themes/lendio-standards/blocks/erc-qualification-form/script.js#L120
const THRESHOLD_2020 = 100;
const THRESHOLD_2021 = 500;

const getBusinessStartPeriod = (bv, defaults = {}) => {
  const startDate = get(bv, 'operation_start_date.value') || defaults?.operationStartDate
  if (!startDate) {
    return null;
  }
  const businessStartDate = new Date(startDate)
  if (!isValid(businessStartDate)) {
    return null;
  }

  const feb2020 = new Date('2020-02-01');
  const jan2022 = new Date('2022-01-01');

  if (isBefore(businessStartDate, feb2020)) {
    return 'beforeFeb2020';
  }

  if (isBefore(businessStartDate, jan2022)) {
    return 'afterFeb2020';
  } else {
    return 'afterJan2022';
  }
}

const parseBoolean = (value, defaultValue) => {
  if (typeof value === 'boolean') {
    return value
  }
  if (typeof value === 'string' && !value.trim().length) {
    return value === '1' || value.toLowerCase() === 'true'
  }
  if (Number.isInteger(value)) {
    return value === 1
  }

  if (typeof defaultValue === 'string') {
    return defaultValue === '1' || defaultValue.toLowerCase() === 'true'
  } else if (Number.isInteger(defaultValue)) {
    return value === 1
  }

  return defaultValue;
}

export default function(borrowerValues, defaults = {}) {
  const unqualifiedRes = {'qualified': false, 'amount': null};

  const employees2020 = Number(get(borrowerValues, 'average_employees_2020.value') || defaults?.avgEmployees2020) || 0;
  const employees2021 = Number(get(borrowerValues, 'average_employees_2021.value') || defaults?.avgEmployees2021) || 0;

  const hasW2Employees = parseBoolean(get(borrowerValues, 'has_w2_employees.value'), defaults?.hasW2Employees);
  const ercBusinessStart = getBusinessStartPeriod(borrowerValues, defaults)

  const isImpactedByGovtOrder = parseBoolean(get(borrowerValues, 'impacted_by_govt_order.value'), defaults?.isImpactedByGovtOrder)
  const revenueDecreased2020Or2021 = parseBoolean(get(borrowerValues, 'revenue_decreased_2020_2021.value'), defaults?.revenueDecreased2020Or2021)

  if (hasW2Employees !== true) {
    return unqualifiedRes;
  } else if (!ercBusinessStart || ercBusinessStart === 'afterJan2022') {
    return unqualifiedRes;
  } else if (employees2020 <= 0 && employees2021 <= 0) {
    return unqualifiedRes;
  } else if (employees2020 > THRESHOLD_2020 || employees2021 > THRESHOLD_2021) {
    return unqualifiedRes;
  } else if (isImpactedByGovtOrder !== true &&
    revenueDecreased2020Or2021 !== true &&
    ercBusinessStart === 'beforeFeb2020') {
    return unqualifiedRes;
  } else if (isImpactedByGovtOrder !== true &&
    revenueDecreased2020Or2021 !== true &&
    ercBusinessStart === 'afterFeb2020') {
    let amount = 0;
    if (employees2021 > 7) {
      amount = 100000;
    } else if (employees2021 > 0) {
      amount = employees2021 * 7000 * 2;
    }
    return {'qualified': true, 'amount': amount};
  } else {
    const amount = (employees2020 * 5000) + (employees2021 * 21000);
    return {'qualified': true, 'amount': amount};
  }
}
